<template>
	<div class="innerPage">
		<div class="tab-content">
			<div
				role="tabpanel"
				aria-hidden="false"
				class="fade tab-pane active show"
			>
				<div v-if="succesfullyDeleted == false" class="bgImg profileContainer">
					<div class="formBox">
						<div class="titleContainer">
							<h1 class="title">הפרופיל שלי</h1>
						</div>
						<div class="formContainer">
							<div class="inputContainer suffix title" data-content="שם פרטי">
								<p class="genericInput">
									{{ userFirstName }}
								</p>
							</div>
							<div class="inputContainer suffix title" data-content="שם משפחה">
								<p class="genericInput">
									{{ userLastName }}
								</p>
							</div>
							<div
								class="inputContainer suffix title"
								data-content="דואר אלקטרוני"
							>
								<p class="genericInput">
									{{ email }}
								</p>
							</div>
						</div>
						<div>
							<button
								@click="showDelete = !showDelete"
								style="height: 48.75px"
								class="btn"
							>
								מחיקת חשבון
							</button>
						</div>
						<div
							v-if="showDelete"
							style="margin-top: 15px"
							class="formContainer"
						>
							<div
								class="inputContainer suffix title"
								data-content="על מנת למחוק חשבון יש להזין סיסמא"
							>
								<input
									type="password"
									v-model="password"
									class="genericInput"
								/>
							</div>
							<div>
								<button
									@click="deleteUser"
									style="height: 48.75px"
									class="btn blue"
								>
									מחיקת חשבון
								</button>
							</div>
							<p style="color: red; height: 16.25px">{{ errorText }}</p>
						</div>
					</div>
				</div>
				<div v-else class="bgImg profileContainer">
					<div class="formBox">
						<div class="inputContainer suffix title">
							<h1 class="title">המשתמש נמחק בהצלחה!</h1>
						</div>

						<div class="inputContainer suffix title">
							<button
								@click="backToLogin"
								style="height: 48.75px"
								class="btn blue"
							>
								אישור
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "UserProfile",
	data() {
		return {
			showDelete: false,
			password: null,
			errorText: null,
			succesfullyDeleted: false,
		};
	},
	computed: {
		email() {
			if (this.$store.state.currentUser == null) {
				return null;
			}
			return this.$store.state.currentUser.useremail;
		},
		userName() {
			if (this.$store.state.currentUser != null) {
				if (Object.prototype.hasOwnProperty.call(this.$store.state.currentUser, "userName") == true) {
					return this.$store.state.currentUser.userName;
				}
				else if (Object.prototype.hasOwnProperty.call(this.$store.state.currentUser, "username") == true) {
					return this.$store.state.currentUser.username;
				}
				else{
					return null;
				}
			}
			else{
				// try from cookie
				const currentUser = this.mixin_getCookie('user');
				if (currentUser != null) {
					return currentUser.userName;
				}
				else{
					return null;
				}
			}

		},
		userFirstName(){
			if (this.userName != null){
				return this.userName.split(" ")[0];
			}
			return null

		},
		userLastName(){
			if (this.userName != null){
				return this.userName.split(" ")[1];
			}
			return null
			
		},

	},
	methods: {
		toggleShowDelete() {
			this.showDelete = !this.showDelete;
		},
		async deleteUser() {
			//try {
				const delete_res = await this.mixin_deleteUser(
					this,
					this.password,
					this.email
				);
				if (delete_res.statusCode === 200) {
					// Remove all cookies
					this.mixin_removeCookie('user');
					this.mixin_removeCookie('up');
					// this.mixin_removeCookie('user');
					// this.mixin_removeCookie("pwd");
					
					// Clear store state
					this.$store.state.currentUser = null;
					this.$store.state.userid = null;      // if you have these
					this.$store.state.username = null;    // if you have these
					this.$store.state.useremail = null;   // if you have these
					
					// Update UI
					this.succesfullyDeleted = true;
					
					// Optional: Redirect to home or login page
					this.mixin_goTo(this, 'home');
				} else {
					this.errorText = delete_res.data.message;
				}
			// } catch (error) {
			// 	console.error("Error deleting user:", error);
			// 	this.errorText = "An error occurred while deleting the user";
			// }
		},
		backToLogin() {
			this.mixin_goTo(this, "login");
		},
	},
};
</script>

<style>

@media (min-width: 768px) {
    .inputContainer.suffix .genericInput {
        padding-left: 65px;
        margin-bottom: 20px;
    }
}

.center {
	border: 5px solid;
	margin: auto;
	width: 50%;
	padding: 10px;
}
</style>
